"use client";
import {
  Button,
  FeedbackForm,
} from "@phpcreation/frontend-components-react-nextjs-bundle/components";
import React, { lazy, Suspense, useState } from "react";
import { HiOutlinePaperAirplane } from "react-icons/hi";

const ConfigError: React.FC = () => {
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  return (
    <main className="flex flex-col justify-between items-center">
      <div className={`text-center flex flex-col gap-4`}>
        <h1
          className="font-bold"
          style={{ fontSize: "96px", color: "#d1d5db" }}
        >
          400
        </h1>
        <h2 className="text-3xl font-semibold text-gray-400">
          Configuration Error
        </h2>
        <p className="text-gray-500 mt-2">
          Make sure you have the correct URL or contact support for assistance
        </p>
        <span className="text-gray-400">
          Example of correct URL pattern: https://TENANT.inventory.phpr.link/
        </span>

        <Button
          name="report-button"
          style={{
            border: "1px solid #00afef",
            backgroundColor: isButtonHovered ? "rgba(255, 255, 255, 0.1)" : "transparent",
            color: "#00afef",
            transition: "background-color 0.2s ease",
          }}
          onMouseEnter={() => setIsButtonHovered(true)}
          onMouseLeave={() => setIsButtonHovered(false)}
          onClick={() => setOpenFeedbackModal(true)}
        >
          <HiOutlinePaperAirplane className="h-4 w-4" />
          &nbsp; Report a problem
        </Button>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "8px" }}>
          <a
            href="https://phpreaction.com/espace-client/situation"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#00afef",
              textDecoration: "underline",
              fontSize: "14px",
            }}
          >
            Report a situation on PHPReaction
          </a>
          <a
            href="mailto:support@phpcreation.com"
            style={{
              color: "#00afef",
              textDecoration: "underline",
              fontSize: "14px",
            }}
          >
            Contact support: support@phpcreation.com
          </a>
        </div>

        <Suspense fallback={<div />}>
          {openFeedbackModal && (
            <FeedbackForm
              isOpen={openFeedbackModal}
              onClose={() => setOpenFeedbackModal(false)}
            />
          )}
        </Suspense>
      </div>
    </main>
  );
};

export default ConfigError;
